module.exports = __webpack_public_path__ + "img/checked_checkboxes-green.384d20b7.svg";